<div class="report-container" style="padding:10px; font-family: Arial, sans-serif;">

  <!-- ================= HEADER ================= -->
  <table style="width: 100%; border-collapse: collapse; border-bottom: 1px solid black; background-color: #f8f9fa;overflow-x: auto;">
    <tr>
      <td style="font-size: 18px; font-weight: bold; text-align: center; padding: 8px;">
        हिंदुस्तान प्रकाशन संस्था
      </td>
      <td style="font-size: 20px; font-weight: bold; text-align: center;">
        Business Report
      </td>
      <td style="font-size: 16px; text-align: right; padding: 8px; font-weight: bold;">
        दिनांक : {{ today | date:'dd-MM-yyyy' }}
      </td>
    </tr>
    <tr style="border-top: 1px solid black;">
      <td style="font-size: 16px; font-weight: bold; text-align: center; padding: 8px;">
        विवेक पुस्तक प्रकाशन
      </td>
      <td style="font-size: 16px; font-weight: bold; text-align: center;">
        Office Representative Monthwise Report
      </td>
      <td style="font-size: 14px; text-align: right; padding: 8px; font-weight: bold;">
        From {{ startDate | date:'dd-MM-yyyy' }} 
        To {{ endDate | date:'dd-MM-yyyy' }}
      </td>
    </tr>
  </table>

  <!-- ================= SCROLLABLE TABLE CONTAINER ================= -->
  <div id="print-section" style="overflow-x: auto; border: 1px solid #ccc;margin-top:0 px;">
    <table class="report-table" style="width: max-content; min-width: 100%; border-collapse: collapse; border: 1px solid black;">

      <!-- Optional: define fixed column widths for better control -->
      <colgroup>
        <col style="width: 50px;" /> <!-- Serial No -->
        <col style="width: 180px;" /> <!-- Name -->
        <!-- Repeat 3 cols per month: ~70px each -->
        <ng-container *ngFor="let month of monthKeys">
          <col style="width: 70px;" />
          <col style="width: 70px;" />
          <col style="width: 70px;" />
        </ng-container>
        <!-- Year Total (3 columns) -->
        <col style="width: 70px;" />
        <col style="width: 70px;" />
        <col style="width: 70px;" />
      </colgroup>

      <thead>
        <tr >
          <th rowspan="2" style="border: 1px solid black; padding: 4px; white-space: nowrap;">अ.क्र.</th>
          <th rowspan="2" style="border: 1px solid black; padding: 4px; white-space: nowrap; min-width: 180px;">प्रतिनिधी नाव</th>

          <th *ngFor="let month of monthKeys" colspan="3" style="border: 1px solid black; padding: 4px; white-space: nowrap;">
            {{ monthNames[month] || month }}
          </th>

          <th colspan="3" style="border: 1px solid black; padding: 4px; white-space: nowrap;">वर्ष {{ selectedYear }}</th>
        </tr>

        <tr style=" color: #000;">
          <ng-container *ngFor="let month of monthKeys">
            <th style="border: 1px solid black; padding: 4px; white-space: nowrap;">बिलिंग</th>
            <th style="border: 1px solid black; padding: 4px; white-space: nowrap;">भरले</th>
            <th style="border: 1px solid black; padding: 4px; white-space: nowrap;">बाकी</th>
          </ng-container>
          <th style="border: 1px solid black; padding: 4px; white-space: nowrap;">बिलिंग</th>
          <th style="border: 1px solid black; padding: 4px; white-space: nowrap;">भरले</th>
          <th style="border: 1px solid black; padding: 4px; white-space: nowrap;">बाकी</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let rep of representatives; let i = index" style="border: 1px solid black;">
          <td class="center" style="border: 1px solid black; padding: 4px; text-align: right; white-space: nowrap;">{{ i + 1 }}</td>
          <td class="left" style="border: 1px solid black; padding: 4px; white-space: nowrap; font-weight: 600;">{{ rep.name }}</td>

          <ng-container *ngFor="let month of monthKeys">
            <td class="right" style="border: 1px solid black; padding: 4px; text-align: right; white-space: nowrap;">{{ rep[month]?.billing || 0 }}</td>
            <td class="right" style="border: 1px solid black; padding: 4px; text-align: right; white-space: nowrap;">{{ rep[month]?.paid || 0 }}</td>
            <td class="right" style="border: 1px solid black; padding: 4px; text-align: right; white-space: nowrap;">{{ rep[month]?.remaining || 0 }}</td>
          </ng-container>

          <td class="right" style="border: 1px solid black; padding: 4px; text-align: right; white-space: nowrap;">{{ rep.yearTotal?.billing || 0 }}</td>
          <td class="right" style="border: 1px solid black; padding: 4px; text-align: right; white-space: nowrap;">{{ rep.yearTotal?.paid || 0 }}</td>
          <td class="right" style="border: 1px solid black; padding: 4px; text-align: right; white-space: nowrap;">{{ rep.yearTotal?.remaining || 0 }}</td>
        </tr>
      </tbody>

      <tfoot>
        <tr class="total-row" style="background-color:#c8753f; font-weight: bold;">
          <th colspan="2" style="border: 1px solid black; padding: 4px; white-space: nowrap;">एकूण</th>

          <ng-container *ngFor="let month of monthKeys">
            <th style="border: 1px solid black; padding: 4px; text-align: right; white-space: nowrap;">{{ totals[month]?.billing || 0 }}</th>
            <th style="border: 1px solid black; padding: 4px; text-align: right; white-space: nowrap;">{{ totals[month]?.paid || 0 }}</th>
            <th style="border: 1px solid black; padding: 4px; text-align: right; white-space: nowrap;">{{ totals[month]?.remaining || 0 }}</th>
          </ng-container>

          <th style="border: 1px solid black; padding: 4px; text-align: right; white-space: nowrap;">{{ grandYearTotal.billing }}</th>
          <th style="border: 1px solid black; padding: 4px; text-align: right; white-space: nowrap;">{{ grandYearTotal.paid }}</th>
          <th style="border: 1px solid black; padding: 4px; text-align: right; white-space: nowrap;">{{ grandYearTotal.remaining }}</th>
        </tr>
      </tfoot>

    </table>
  </div>

  <!-- ================= BUTTONS ================= -->
  <div class="noPrint" style="margin-top:15px; text-align:center;">
    <button mat-raised-button color="primary" (click)="exportExcel('OfficeRep_Report')">
      📊 Export
    </button>

    <button mat-raised-button color="accent" (click)="printReportA3Landscape()">
      🖨️ Print
    </button>

    <button mat-button mat-dialog-close>
      ❌ Close
    </button>
  </div>

</div>